function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-7995.831-1004.646l.263-29.809a.755.755,0,0,1,1.319-.573l12.651,15.076a.849.849,0,0,1,0,1.09l-12.914,14.789a.7.7,0,0,1-.546.272A.812.812,0,0,1-7995.831-1004.646Zm-17.069,0,.264-29.809a.755.755,0,0,1,1.319-.573l12.651,15.076a.85.85,0,0,1,0,1.09l-12.915,14.789a.7.7,0,0,1-.546.272A.812.812,0,0,1-8012.9-1004.646Z",
  transform: "translate(8013.4 1035.82)",
  fill: "#109dff",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

function SvgTitreProc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.548,
    height: 32.519,
    viewBox: "0 0 32.548 32.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitreProc);
export default __webpack_public_path__ + "static/media/titre_proc.6d940bd9.svg";
export { ForwardRef as ReactComponent };